import React, { useEffect, useState } from 'react'
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';

const Homeaboutus = () => {

    const [homeaboutus, setHomeaboutus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchhomeaboutus = async () => {
            try {
                const homeaboutusData = await ApiService.Commanfetchrequest("home-aboutus");
                setHomeaboutus(homeaboutusData);
                // console.log('Fetched About us:', homeaboutusData);
            } catch (error) {
                console.error('Error fetching home feature:', error);

            } finally {
                setLoading(false);
            }
        }

        fetchhomeaboutus();

    }, []);

    return (

        <>
            {loading ? (
                <section id="about" className="about section">
                    <div className="container">
                        <div className="row gy-4">
                            <div className="col-lg-6 content">
                                <p className="who-we-are"><Skeleton width={100} height={20} /></p>
                                <h3><Skeleton width={"100%"} height={50} /></h3>
                                <p className="fst-italic">
                                </p><p>
                                    <Skeleton width={"100%"} height={200} />
                                </p>
                                <p />
                                <ul>
                                    <li><i className="bi bi-check-circle" /> <span><Skeleton width={150} height={20} /></span></li>
                                    <li><i className="bi bi-check-circle" /> <span><Skeleton width={150} height={20} /></span></li>
                                    <li><i className="bi bi-check-circle" /> <span><Skeleton width={150} height={20} /></span></li>
                                </ul>
                                <Skeleton width={160} height={50} />
                            </div>
                            <div className="col-lg-6 about-images">
                                <div className="row gy-4">
                                    <div className="col-lg-6">
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row gy-4">
                                            <div className="col-lg-12">
                                                <Skeleton width={"100%"} height={130} />
                                            </div>
                                            <div className="col-lg-12">
                                                <Skeleton width={"100%"} height={130} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                homeaboutus && (
                    <>
                        <section id="about" className="about section">
                            <div className="container">
                                <div className="row gy-4">
                                    <div className="col-lg-6 content">
                                        <p className="who-we-are">Who We Are</p>
                                        <h3>{homeaboutus.heading}</h3>
                                        <p className="fst-italic">
                                        </p>
                                        <p dangerouslySetInnerHTML={{ __html: homeaboutus?.description }}>
                                            
                                        </p>
                                        <p />
                                        <ul>
                                            <li><i className="bi bi-check-circle" /> <span>{homeaboutus?.title_first}</span></li>
                                            <li><i className="bi bi-check-circle" /> <span>{homeaboutus?.title_second}</span></li>
                                            <li><i className="bi bi-check-circle" /> <span>{homeaboutus?.title_third}</span></li>
                                        </ul>
                                        <a href="#" className="read-more"><span>Read More</span><i className="bi bi-arrow-right" /></a>
                                    </div>
                                    <div className="col-lg-6 about-images">
                                        <div className="row gy-4">
                                            <div className="col-lg-6">
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="row gy-4">
                                                    <div className="col-lg-12">
                                                        <img src={`https://sigohrmlpadmin.loopring.in/front/images/homeaboutus/${homeaboutus.homeaboutus_image}`} className="img-fluid" alt />
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <img src="https://sigohrmlpadmin.loopring.in/front/images/about-company-3.jpg" className="img-fluid" alt />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )

            )}

        </>



    )
}

export default Homeaboutus
